import { useState } from 'react'
import { useWorkspaceStore } from '@/store/workspaceStore'
import { useWorkspaces } from '@/hooks/useWorkspaces'
import CreateWorkspaceDialog from './CreateWorkspaceDialog.jsx'
import WorkspaceTilesScroll from './WorkspaceTilesScroll.jsx'
import { useWorkspaceSwitcher } from './useWorkspaceSwitcher.js'

export default function WorkspaceTiles() {
  const query = useWorkspaces()
  const workspaces = query.data?.workspaces ?? []
  const activeId = useWorkspaceStore((s) => s.activeWorkspaceId)
  const switchWorkspace = useWorkspaceSwitcher()
  const [dialogOpen, setDialogOpen] = useState(false)
  return (
    <>
      <WorkspaceTilesScroll
        query={query}
        workspaces={workspaces}
        activeId={activeId}
        onSelect={switchWorkspace}
        onAdd={() => setDialogOpen(true)}
      />
      <CreateWorkspaceDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  )
}
